// Copyright (c) 2016 Deere & Company

import PipCodeRequestContainer from '../../pip/pip-code/state-connector';

export default {
    component: PipCodeRequestContainer,
    name: 'PIP_CODE_REQUEST',
    path: 'pip-code-request/:id'
};



// WEBPACK FOOTER //
// ./src/routes/pips/pip-code-request.js